import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Calendar as CalendarIcon } from 'lucide-react';
import { useLanguage } from '@/context/language-context';

interface LoginPromptProps {
  isOpen: boolean;
  onClose: () => void;
}

export const LoginPrompt: React.FC<LoginPromptProps> = ({ isOpen, onClose }) => {
  const { t, getUrlWithLanguage } = useLanguage();

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[500px] p-0 overflow-hidden">
        <DialogHeader className="bg-gradient-to-r from-pink-500 to-pink-600 px-6 py-4">
          <DialogTitle className="text-white flex items-center">
            <CalendarIcon className="mr-2 h-5 w-5" />
            {t('profile:booking')} {/* Keep title consistent */}
          </DialogTitle>
        </DialogHeader>
        
        <div className="p-6 text-center">
          <CalendarIcon className="mx-auto h-12 w-12 text-pink-500 mb-4" />
          <h3 className="text-lg font-medium mb-2">{t('common:login_required')}</h3>
          <p className="text-muted-foreground mb-6">
            {t('common:login_to_book')}
          </p>
          <Button 
            className="w-full bg-gradient-to-r from-pink-500 to-pink-600 hover:from-pink-600 hover:to-pink-700"
            // Use navigate from react-router-dom if available, otherwise fallback to window location
            onClick={() => window.location.href = getUrlWithLanguage('/login')} 
          >
            {t('common:login_signup')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}; 